import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import ModalContainer from '../../../../ModalContainer/ModelContainer'
import TextField from '../../../../FormLegacy/FormFieldsV2/TextField'
import ToggleField from '../../../../FormLegacy/FormFieldsV2/ToggleField'

const getVehicleFormFields = (t) => [
  {
    id: 'modelYear',
    label: t('checklists-create-task:realPageForm.fields.modelYear'),
    type: 'short_answer',
    typeLabel: t('checklists-create-task:realPageForm.inputTypes.shortAnswer'),
    required: true,
    validation: {
      maxLength: 4,
      pattern: '^\\d{4}$',
    },
    dataType: 'Integer',
  },
  {
    id: 'make',
    label: t('checklists-create-task:realPageForm.fields.make'),
    type: 'short_answer',
    typeLabel: t('checklists-create-task:realPageForm.inputTypes.shortAnswer'),
    required: false,
    validation: {
      maxLength: 30,
    },
    dataType: 'String',
  },
  {
    id: 'model',
    label: t('checklists-create-task:realPageForm.fields.model'),
    type: 'short_answer',
    typeLabel: t('checklists-create-task:realPageForm.inputTypes.shortAnswer'),
    required: false,
    validation: {
      maxLength: 30,
    },
    dataType: 'String',
  },
  {
    id: 'licensePlate',
    label: t('checklists-create-task:realPageForm.fields.licensePlate'),
    type: 'short_answer',
    typeLabel: t('checklists-create-task:realPageForm.inputTypes.shortAnswer'),
    required: false,
    validation: {
      maxLength: 30,
    },
    dataType: 'String',
  },
  {
    id: 'color',
    label: t('checklists-create-task:realPageForm.fields.color'),
    type: 'short_answer',
    typeLabel: t('checklists-create-task:realPageForm.inputTypes.shortAnswer'),
    required: false,
    validation: {
      maxLength: 30,
    },
    dataType: 'String',
  },
  {
    id: 'permitTag',
    label: t('checklists-create-task:realPageForm.fields.permitTag'),
    type: 'short_answer',
    typeLabel: t('checklists-create-task:realPageForm.inputTypes.shortAnswer'),
    required: false,
    validation: {
      maxLength: 30,
    },
    dataType: 'String',
  },
]

const VehicleFormModal = ({ onClose }) => {
  const { t } = useTranslation(['checklists-create-task'])
  const vehicleFormFields = getVehicleFormFields(t)
  return (
    <ModalContainer
      additionalClass="realpage-form-modal"
      onClose={onClose}
      headerTitle={t('checklists-create-task:realPageForm.vehicleFormModalHeaderTitle')}
    >
      <div className="realpage-form-modal-content">
        {vehicleFormFields.map((field) => (
          <div key={field.id} className="realpage-form-modal-content__field">
            <div className="realpage-form-modal-content__input-row">
              <TextField
                label={t('checklists-create-task:dataInput.taskItemLabelLabel')}
                value={field.label}
                disabled
              />
              <TextField
                name="short-answer"
                label={t('checklists-create-task:realPageForm.inputTypeLabel')}
                value={field.typeLabel}
                disabled
              />
            </div>
            <ToggleField
              label={t('checklists-create-task:dataInput.requiredLabel')}
              labelOnRight
              value={field.required}
              disabled
            />
          </div>
        ))}
      </div>
    </ModalContainer>
  )
}

VehicleFormModal.propTypes = {
  onClose: PropTypes.func,
}

export default VehicleFormModal
